import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { LABEL_FRAGMENT } from './label'

import type { AbTestsParametersSchemaDTO } from 'features/ab-tests/api/types/abTestsParametersSchemaDTO'

export const UNFILLED_RECOVERY_FRAGMENT: TypedDocumentNode<
  AbTestsParametersSchemaDTO['unfilledRecovery']
> = gql`
  ${LABEL_FRAGMENT}

  fragment unfilledRecoveryFragment on AbTestsParametersUnfilledRecovery {
    unfilledRecoveryEnabled {
      ...labelFragment
    }
    prebidBehaviourType {
      ...labelFragment
    }
    label
  }
`
